import {
  prrPercentFormatter,
  primaryOwnerFormatter,
  productTypeFormatter,
  retirementAccountFormatter,
  dateFormatter,
  productClassFormatter,
  modelBenchmarkFormatter,
  dashFormatter,
  personalInvestmentFormatter
} from 'services/TableUtils';

export const defaultColDef = {
  sortable: true,
  suppressMenu: true,
  suppressMovable: true,
  aggFunc: 'sum',
  minWidth: 89
};

export const autoGroupColumnDef = {
  headerName: '',
  field: 'accountNameAndNumber',
  pinned: 'left',
  minWidth: 340,
  width: 340,
  maxWidth: 340,
  sort: 'asc',
  cellClass: 'pinned-cell-align',
  autoHeight: true,
  resizable: true,
  cellRendererParams: {
    suppressCount: true,
    suppressDoubleClickExpand: true,
    suppressEnterExpand: true,
    suppressPadding: true,
    innerRenderer: 'accountNameRenderer'
  }
};

export const autoGroupColumnDefMobile = {
  headerName: '',
  field: 'accountNameAndNumber',
  wrapText: true,
  autoHeight: true,
  minWidth: 224,
  maxWidth: 224,
  width: 224,
  sort: 'asc',
  suppressSizeToFit: true,
  cellClass: 'pinned-cell-align lock-pinned',
  rowGroupIndex: 4,
  cellRendererParams: {
    suppressCount: true,
    suppressDoubleClickExpand: true,
    suppressEnterExpand: true,
    suppressPadding: true,
    innerRenderer: 'accountNameRenderer'
  }
};

export function ColumnDefFactory(
  retirement,
  has529Only,
  hasAlaska529Only = false,
  hasMultipleAPP,
  closed
) {
  this.createColumnDef = (key) => {
    let def;

    if (isRowGroup(key)) {
      def = new RowGroupCol(key, retirement, has529Only, hasAlaska529Only);
    } else if (isRegCol(key)) {
      def = new RegCol(key, hasMultipleAPP, closed);
    } else {
      def = new HiddenCol();
    }

    def.field = key;

    return def;
  };
}

const rowGroups = [
  'personalInvestment',
  'productClass',
  'rasBenchmarkRow',
  'retirementAccount',
  'productType',
  'typeAndOwners'
];

const isRowGroup = (key) => rowGroups.includes(key);

const isRegCol = (key) => {
  return (
    key === 'monthToDateRateOfReturn' ||
    key === 'quarterToDateRateOfReturn' ||
    key === 'lastQuarterReturn' ||
    key === 'ytdReturn' ||
    key === 'oneYearReturn' ||
    key === 'threeYearReturn' ||
    key === 'fiveYearReturn' ||
    key === 'tenYearReturn' ||
    key === 'inceptionReturn' ||
    key === 'inceptionDate'
  );
};

const orderedRowGroups = [
  'personalInvestment',
  'productClass',
  'rasBenchmarkRow',
  'retirementAccount',
  'isOwner',
  'productType',
  'typeAndOwners'
];
const orderedRetirementRowGroups = [
  'productClass',
  'rasBenchmarkRow',
  'retirementAccount',
  'isOwner',
  'productType',
  'typeAndOwners'
];

const RowGroupCol = function (key, retirement, has529Only, hasAlaska529Only) {
  this.headerName = '';
  this.rowGroup = true;
  this.hide = true;
  this.cellClass = 'pinned-cell-align';
  this.rowGroupIndex = retirement
    ? orderedRetirementRowGroups.indexOf(key)
    : orderedRowGroups.indexOf(key);

  if (key === 'personalInvestment') {
    this.valueFormatter = personalInvestmentFormatter;
  }

  if (key === 'productClass') {
    this.valueFormatter = productClassFormatter(hasAlaska529Only);
  }

  if (key === 'rasBenchmarkRow') {
    this.valueFormatter = modelBenchmarkFormatter;
  }

  if (key === 'retirementAccount') {
    this.valueFormatter = retirementAccountFormatter;
  }

  if (key === 'productType') {
    this.valueFormatter = productTypeFormatter;
  }

  if (key === 'typeAndOwners') {
    this.valueFormatter = primaryOwnerFormatter;
  }
};

const HiddenCol = function () {
  this.hide = true;
};

const RegCol = function (key, hasMultipleAPP, closed) {
  this.valueFormatter = closed
    ? dashFormatter
    : prrPercentFormatter(hasMultipleAPP);

  if (key === 'monthToDateRateOfReturn') {
    this.headerName = 'Month-to-Date';
  }

  if (key === 'quarterToDateRateOfReturn') {
    this.headerName = 'Quarter-to-Date';
  }

  if (key === 'lastQuarterReturn') {
    this.headerName = 'Last Calendar Quarter';
  }

  if (key === 'ytdReturn') {
    this.headerName = 'Year-to-Date';
  }

  if (key === 'oneYearReturn') {
    this.headerName = '1 Year';
  }

  if (key === 'threeYearReturn') {
    this.headerName = '3 Year';
  }

  if (key === 'fiveYearReturn') {
    this.headerName = '5 Year';
  }

  if (key === 'tenYearReturn') {
    this.headerName = '10 Year';
  }

  if (key === 'inceptionReturn') {
    this.headerName = 'Since Inception';
    this.minWidth = 100;
  }

  if (key === 'inceptionDate') {
    this.headerName = 'Inception Date';
    this.minWidth = 100;
    this.valueFormatter = dateFormatter;
  }
};
